import { render, staticRenderFns } from "./thirdPartyDialog.vue?vue&type=template&id=ff196490&scoped=true"
import script from "./thirdPartyDialog.vue?vue&type=script&lang=js"
export * from "./thirdPartyDialog.vue?vue&type=script&lang=js"
import style0 from "./thirdPartyDialog.vue?vue&type=style&index=0&id=ff196490&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff196490",
  null
  
)

export default component.exports